/** Local-DB community `_id` the mock opportunities are scoped to. */
export const DEMO_COMMUNITY_ID = '6678545ec2eb84a60c2800e5' // Ask An Orange (dev)

/**
 * Submitter identities rotated across the fixture so the "Submitted By"
 * section on the detail view doesn't read as one person posting everything.
 * `bulk` channel opps don't have a human submitter — the ingestion comes
 * from a job-board feed, so source.firstName/lastName/email are null.
 */
const SUBMITTER_ALEX = {
  firstName: 'Alex',
  lastName: 'Johnson',
  email: 'alex.johnson@example.com',
}
const SUBMITTER_SARAH = {
  firstName: 'Sarah',
  lastName: 'Chen',
  email: 'sarah.chen@example.com',
}
const SUBMITTER_MARCUS = {
  firstName: 'Marcus',
  lastName: 'Reyes',
  email: 'marcus.reyes@example.com',
}

const sourceProgramPage = (submitter) => ({
  channel: 'program-page',
  firstName: submitter.firstName,
  lastName: submitter.lastName,
  email: submitter.email,
})
const sourceDashboard = (submitter) => ({
  channel: 'dashboard',
  firstName: submitter.firstName,
  lastName: submitter.lastName,
  email: submitter.email,
})
const sourceBulk = () => ({
  channel: 'bulk',
  firstName: null,
  lastName: null,
  email: null,
})

export const MOCK_OPPORTUNITIES = [
  {
    _id: 'OPP-20260307-4821',
    title: 'Software Engineer II',
    company: 'Garmin International',
    location: 'Olathe, KS (Hybrid)',
    jobType: 'Full-Time',
    status: 'active',
    submittedDate: '2026-03-07',
    expirationDate: '2026-06-05',
    deadline: '2026-04-15',
    description:
      'Garmin International is expanding their avionics software team and is looking for an experienced software engineer passionate about cutting-edge navigation technology. This role focuses on embedded systems development, firmware engineering, and collaborative work with cross-functional hardware teams. The successful candidate will design, implement, and maintain real-time software for aviation-grade products, contribute to architecture decisions across the embedded stack, and partner closely with hardware, QA, and certification teams. Garmin offers a strong culture of engineering rigour, on-site labs in Olathe, and a comprehensive benefits package including profit sharing and continued education support.',
    applicationUrl: 'https://careers.garmin.com/careers/software-engineer-ii',
    industry: ['Technology'],
    skills: ['Embedded Systems', 'C / C++', 'Firmware Engineering', 'RTOS', 'Avionics'],
    requiredExperienceYears: 3,
    requiredEducation: 'bachelors',
    clickCount: 24,
    applicationCount: 2,
    source: sourceProgramPage(SUBMITTER_ALEX),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 95000, end: 120000 },
  },
  {
    _id: 'OPP-20260305-3411',
    title: 'Data Analyst – Supply Chain',
    company: 'Koch Industries',
    location: 'Wichita, KS',
    jobType: 'Full-Time',
    status: 'active',
    submittedDate: '2026-03-05',
    expirationDate: '2026-06-03',
    deadline: '2026-04-30',
    description:
      'Koch Industries is hiring a Data Analyst for its supply-chain analytics team. The analyst will partner with logistics, procurement, and finance stakeholders to surface insights from large operational datasets, design dashboards in Tableau / Power BI, and prototype predictive models for demand and inventory planning.',
    applicationUrl: 'https://kochcareers.com/jobs/data-analyst-supply-chain',
    industry: ['Manufacturing', 'Logistics'],
    skills: ['SQL', 'Python', 'Tableau', 'Power BI', 'Statistics'],
    requiredExperienceYears: 2,
    requiredEducation: 'bachelors',
    clickCount: 17,
    applicationCount: 0,
    source: sourceDashboard(SUBMITTER_SARAH),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 75000, end: 95000 },
  },
  {
    _id: 'OPP-20260304-9082',
    title: 'Agricultural Research Scientist',
    company: 'Bayer Crop Science',
    location: 'St. Louis, MO',
    jobType: 'Full-Time',
    status: 'in_review',
    submittedDate: '2026-03-04',
    expirationDate: '2026-06-02',
    deadline: '2026-05-10',
    description:
      'Bayer Crop Science is seeking a Research Scientist to join the seeds breeding program. The role involves trial design, field-data collection, and statistical analysis of yield outcomes across multiple growing regions.',
    applicationUrl: 'https://career.bayer.com/jobs/agricultural-research-scientist',
    industry: ['Agriculture', 'Biotech'],
    skills: ['R', 'Field Trials', 'Plant Genetics', 'Statistical Modeling'],
    requiredExperienceYears: 4,
    requiredEducation: 'masters',
    clickCount: 0,
    applicationCount: 1,
    source: sourceProgramPage(SUBMITTER_MARCUS),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 85000, end: 105000 },
  },
  {
    _id: 'OPP-20260228-5512',
    title: 'Civil Engineer – Infrastructure',
    company: 'HNTB Corporation',
    location: 'Kansas City, MO',
    jobType: 'Full-Time',
    status: 'active',
    submittedDate: '2026-02-28',
    expirationDate: '2026-05-28',
    deadline: '2026-04-20',
    description:
      'HNTB is looking for a Civil Engineer to join its public-infrastructure practice. The role supports transportation projects across the Midwest, with responsibilities spanning design, drafting, and on-site coordination.',
    applicationUrl: 'https://hntb.com/careers/civil-engineer-infrastructure',
    industry: ['Engineering', 'Construction'],
    skills: ['AutoCAD', 'Civil 3D', 'Project Management', 'Hydraulics'],
    requiredExperienceYears: 5,
    requiredEducation: 'bachelors',
    clickCount: 0,
    applicationCount: 0,
    source: sourceBulk(),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 70000, end: 88000 },
  },
  {
    _id: 'OPP-20260220-7733',
    title: 'Financial Analyst',
    company: 'Cerner Corporation',
    location: 'North Kansas City, MO',
    jobType: 'Full-Time',
    status: 'closed',
    submittedDate: '2026-02-20',
    expirationDate: '2026-05-20',
    deadline: '2026-03-30',
    description:
      'Financial Analyst role supporting the healthcare-IT product line. Owns monthly close, variance analysis, and partners with product management on revenue forecasts.',
    applicationUrl: 'https://cerner.com/careers/financial-analyst',
    industry: ['Healthcare', 'Finance'],
    skills: ['Excel', 'Financial Modeling', 'SAP', 'Forecasting'],
    requiredExperienceYears: 3,
    requiredEducation: 'bachelors',
    clickCount: 0,
    applicationCount: 0,
    source: sourceDashboard(SUBMITTER_SARAH),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 65000, end: 80000 },
  },
  {
    _id: 'OPP-20260306-2244',
    title: 'Marketing Manager',
    company: 'Hallmark Cards',
    location: 'Kansas City, MO',
    jobType: 'Full-Time',
    status: 'active',
    submittedDate: '2026-03-06',
    expirationDate: '2026-06-04',
    deadline: '2026-05-01',
    description:
      'Hallmark is hiring a Marketing Manager for its digital-greeting product line. The role owns go-to-market planning, paid acquisition campaigns, and partner activations.',
    applicationUrl: 'https://hallmark.com/careers/marketing-manager',
    industry: ['Consumer Goods', 'Marketing'],
    skills: ['Campaign Management', 'Google Analytics', 'Brand Strategy', 'Copywriting'],
    requiredExperienceYears: 5,
    requiredEducation: 'bachelors',
    clickCount: 0,
    applicationCount: 0,
    source: sourceProgramPage(SUBMITTER_ALEX),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 80000, end: 100000 },
  },
  {
    _id: 'OPP-20260302-8841',
    title: 'Backend Engineer',
    company: 'Sprint',
    location: 'Overland Park, KS',
    jobType: 'Full-Time',
    status: 'rejected',
    submittedDate: '2026-03-02',
    expirationDate: '2026-05-31',
    deadline: '2026-04-25',
    description:
      'Backend Engineer for the carrier-services platform. Builds and operates Java/Spring micro-services that power subscriber-management workflows.',
    applicationUrl: 'https://sprint.com/careers/backend-engineer',
    industry: ['Telecommunications', 'Technology'],
    skills: ['Java', 'Spring Boot', 'Kafka', 'PostgreSQL', 'Kubernetes'],
    requiredExperienceYears: 4,
    requiredEducation: 'bachelors',
    clickCount: 0,
    applicationCount: 0,
    source: sourceBulk(),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 90000, end: 115000 },
  },
  {
    _id: 'OPP-20260301-9931',
    title: 'Junior Web Developer',
    company: 'Boulevard Brewing',
    location: 'Kansas City, MO',
    jobType: 'Full-Time',
    status: 'incomplete',
    submittedDate: '2026-03-01',
    expirationDate: '2026-05-30',
    deadline: null,
    description:
      'Junior Web Developer to support the e-commerce site and direct-to-consumer ordering experience. Strong fit for a recent graduate ready to ship production code.',
    applicationUrl: 'https://boulevard.com/careers/junior-web-developer',
    industry: ['Food & Beverage', 'E-commerce'],
    skills: ['HTML', 'CSS', 'JavaScript', 'React'],
    requiredExperienceYears: 0,
    requiredEducation: 'bachelors',
    clickCount: 0,
    applicationCount: 0,
    source: sourceProgramPage(SUBMITTER_MARCUS),
    communityId: DEMO_COMMUNITY_ID,
    salary: null,
  },
  {
    _id: 'OPP-20260225-1122',
    title: 'Recruiting Specialist',
    company: 'Cargill',
    location: 'Minneapolis, MN',
    jobType: 'Full-Time',
    status: 'quarantined',
    submittedDate: '2026-02-25',
    expirationDate: '2026-05-25',
    deadline: '2026-04-10',
    description:
      'Recruiting Specialist supporting talent acquisition for the food-ingredients division. Full-cycle recruiting across multiple US sites.',
    applicationUrl: 'https://cargill.com/careers/recruiting-specialist',
    industry: ['Food', 'Agriculture'],
    skills: ['Sourcing', 'ATS Tools', 'Interviewing', 'Employer Branding'],
    requiredExperienceYears: 2,
    requiredEducation: 'bachelors',
    clickCount: 0,
    applicationCount: 0,
    source: sourceBulk(),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 60000, end: 75000 },
  },
  {
    _id: 'OPP-20260224-4455',
    title: 'UX Designer',
    company: 'Hostess Brands',
    location: 'Lenexa, KS',
    jobType: 'Full-Time',
    status: 'active',
    submittedDate: '2026-02-24',
    expirationDate: '2026-05-24',
    deadline: '2026-04-12',
    description:
      'UX Designer for the e-commerce and brand-marketing properties. Owns research, wireframing, and prototyping across the consumer site and internal tools.',
    applicationUrl: 'https://hostess.com/careers/ux-designer',
    industry: ['Consumer Goods', 'Design'],
    skills: ['Figma', 'User Research', 'Prototyping', 'Design Systems'],
    requiredExperienceYears: 3,
    requiredEducation: 'bachelors',
    clickCount: 15,
    applicationCount: 3,
    source: sourceDashboard(SUBMITTER_SARAH),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 75000, end: 95000 },
  },
  {
    _id: 'OPP-20260218-6677',
    title: 'Data Engineer Intern',
    company: 'H&R Block',
    location: 'Kansas City, MO',
    jobType: 'Part-Time',
    status: 'in_review',
    submittedDate: '2026-02-18',
    expirationDate: '2026-05-19',
    deadline: '2026-04-01',
    description:
      'Summer internship for a Data Engineering student. Build ingestion pipelines for tax-document parsing and contribute to the data-quality monitoring suite.',
    applicationUrl: 'https://hrblock.com/careers/data-engineer-intern',
    industry: ['Finance', 'Technology'],
    skills: ['Python', 'SQL', 'Airflow', 'Data Modeling'],
    requiredExperienceYears: 0,
    requiredEducation: 'high-school',
    clickCount: 0,
    applicationCount: 0,
    source: sourceProgramPage(SUBMITTER_ALEX),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 25000, end: 35000 },
  },
  {
    _id: 'OPP-20260215-8899',
    title: 'Quality Assurance Engineer',
    company: 'Spirit AeroSystems',
    location: 'Wichita, KS',
    jobType: 'Full-Time',
    status: 'active',
    submittedDate: '2026-02-15',
    expirationDate: '2026-05-16',
    deadline: '2026-04-18',
    description:
      'QA Engineer for the aerostructures program. Drives test planning, defect tracking, and automation across software systems that support commercial-aircraft manufacturing.',
    applicationUrl: 'https://spiritaero.com/careers/quality-assurance-engineer',
    industry: ['Aerospace', 'Manufacturing'],
    skills: ['Selenium', 'Test Automation', 'Quality Management', 'ISO 9001'],
    requiredExperienceYears: 4,
    requiredEducation: 'bachelors',
    clickCount: 8,
    applicationCount: 0,
    source: sourceDashboard(SUBMITTER_MARCUS),
    communityId: DEMO_COMMUNITY_ID,
    salary: { start: 70000, end: 90000 },
  },
]

/**
 * Single-record lookup mirroring the real `getOpportunity(id)` endpoint
 * that the backend will expose at `/dashboard/recruiting/opportunities/:id`.
 * Returns null when the id isn't in the fixture so the detail view can
 * render its "not found" state cleanly.
 */
export function getMockOpportunityById(id) {
  return MOCK_OPPORTUNITIES.find((o) => o._id === id) || null
}

/**
 * Mock metrics for SCRUM-552's KPI cards on the opportunity detail page.
 *
 * The real backend will expose `GET /dashboard/recruiting/opportunities/:id/metrics`
 * returning `{ matchedCount, clickCount }`.
 *
 * Critically: `clickCount` MUST match what the list view shows in its
 * notification badge for the same opportunity. Earlier this helper
 * returned synthetic values derived from the id, which meant the detail
 * card showed e.g. 11 while the list badge showed 24 for the same row.
 * Now we read clickCount straight from the fixture so list and detail
 * agree.
 *
 * `matchedCount` is derived (no field on MOCK_OPPORTUNITIES) using a
 * realistic conversion rate — typical alumni recruiting funnels see
 * ~30-40% of matched alumni actually click through. The derivation
 * collapses to 0 when an opportunity has no engagement at all so the
 * zero-state remains demonstrable.
 *
 * "clickCount" = alumni-side application-URL click-through (PRD §5.11 /
 * SCRUM-552). NOT opportunity views.
 */
export function getMockMetricsForOpportunity(id) {
  const opp = getMockOpportunityById(id)
  if (!opp) return { matchedCount: 0, clickCount: 0 }
  const clickCount = opp.clickCount || 0

  if (clickCount === 0 && !opp.applicationCount) {
    return { matchedCount: 0, clickCount: 0 }
  }

  const matchedCount = Math.round(clickCount * 2.5 + 4)
  return { matchedCount, clickCount }
}

/**
 * Close-active mutation for SCRUM-598. Mutates the in-memory fixture so
 * both the list and the detail view stay in sync within the session.
 *
 * The real backend will expose `PATCH /dashboard/recruiting/opportunities/:id`
 * with `{ status, reason? }`. Until that lands this helper performs the
 * same state transition locally and stamps the appropriate date field:
 *   - newStatus === 'closed'   → closeDate = today
 *   - newStatus === 'rejected' → rejectionDate = today, rejectionReason = reason
 *   - other transitions stamp `lastStatusChangeAt` for audit
 *
 * @param {string} id           Opportunity id
 * @param {string} newStatus    one of: in_review / active / closed / rejected / incomplete / quarantined
 * @param {string} [reason]     optional reason (stored on rejectionReason for 'rejected')
 * @returns {object|null}       The mutated opportunity, or null if not found
 */
export function setMockOpportunityStatus(id, newStatus, reason) {
  const opp = MOCK_OPPORTUNITIES.find((o) => o._id === id)
  if (!opp) return null
  const today = new Date().toISOString().slice(0, 10)
  opp.status = newStatus
  opp.lastStatusChangeAt = today
  if (newStatus === 'closed') {
    opp.closeDate = today
  }
  if (newStatus === 'rejected') {
    opp.rejectionDate = today
    if (reason) opp.rejectionReason = reason
  }
  if (reason && newStatus !== 'rejected') {
    opp.statusChangeReason = reason
  }
  return opp
}

/**
 * Create-from-dashboard mutation for SCRUM-553.
 *
 * Admin-created opportunities skip the approval queue and land directly
 * as `active` (the admin IS the approver — having them approve their
 * own creation adds friction with zero value). Decision documented at
 * the ticket: "default status for admin-created = active".
 *
 * Source is fixed to `dashboard` per PRD §5.3.2; submitter info is
 * carried so engagement / audit can attribute the post back to the
 * specific admin who created it.
 *
 * The real backend will expose `POST /dashboard/recruiting/opportunities`.
 * Until then this helper does the same shape change locally and prepends
 * the new row so it shows up at the top of the list immediately.
 */
export function createMockOpportunity(payload) {
  const today = new Date().toISOString().slice(0, 10)
  const expiration = new Date()
  expiration.setDate(expiration.getDate() + 90)
  const opp = {
    _id: `OPP-${Date.now()}-${Math.floor(Math.random() * 9000 + 1000)}`,
    title: payload.title,
    company: payload.company,
    location: payload.location,
    jobType: payload.jobType,
    status: 'active',
    submittedDate: today,
    expirationDate: expiration.toISOString().slice(0, 10),
    deadline: payload.deadline || null,
    description: payload.description,
    applicationUrl: payload.applicationUrl,
    industry: payload.industry || [],
    skills: payload.skills || [],
    requiredExperienceYears: payload.requiredExperienceYears || null,
    requiredEducation: payload.requiredEducation || null,
    clickCount: 0,
    applicationCount: 0,
    source: {
      channel: 'dashboard',
      firstName: (payload.submitter && payload.submitter.firstName) || 'Admin',
      lastName: (payload.submitter && payload.submitter.lastName) || 'User',
      email: (payload.submitter && payload.submitter.email) || '',
    },
    communityId: DEMO_COMMUNITY_ID,
    salary:
      payload.salary &&
      (payload.salary.start != null || payload.salary.end != null)
        ? payload.salary
        : null,
  }
  MOCK_OPPORTUNITIES.unshift(opp)
  return opp
}
